// context/AuthContext.jsx  — Restaurant Admin / Staff auth (unchanged logic, adds slug)
import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminApi } from '../services/api';

const AuthContext = createContext(null);

const ADMIN_TOKEN_KEY = 'cafe_admin_token';
const ADMIN_USER_KEY  = 'cafe_admin_user';
const STAFF_TOKEN_KEY = 'cafe_staff_token';
const STAFF_USER_KEY  = 'cafe_staff_user';

const getKeys = (role) => role === 'staff'
  ? { tokenKey: STAFF_TOKEN_KEY, userKey: STAFF_USER_KEY }
  : { tokenKey: ADMIN_TOKEN_KEY, userKey: ADMIN_USER_KEY };

export const AuthProvider = ({ children }) => {
  const [admin,   setAdmin]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isStaffPath = window.location.pathname.includes('/staff');
    if (isStaffPath) {
      const token  = localStorage.getItem(STAFF_TOKEN_KEY);
      const stored = localStorage.getItem(STAFF_USER_KEY);
      if (token && stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed?.role === 'staff') setAdmin(parsed);
        } catch {}
      }
    } else {
      const token  = localStorage.getItem(ADMIN_TOKEN_KEY);
      const stored = localStorage.getItem(ADMIN_USER_KEY);
      if (token && stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed?.role === 'admin') setAdmin(parsed);
        } catch {}
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password, restaurant_id, slug) => {
    const res = await adminApi.login({ email, password, restaurant_id, slug });
    const { token, admin } = res.data.data;
    // slug ko persist karo taaki logout redirect sahi kaam kare
    const adminWithSlug = { ...admin, slug };
    const { tokenKey, userKey } = getKeys(admin.role);
    localStorage.setItem(tokenKey, token);
    localStorage.setItem(userKey, JSON.stringify(adminWithSlug));
    setAdmin(adminWithSlug);
    return adminWithSlug;
  };

  const logout = (slug) => {
    if (admin?.role === 'staff') {
      localStorage.removeItem(STAFF_TOKEN_KEY);
      localStorage.removeItem(STAFF_USER_KEY);
    } else {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      localStorage.removeItem(ADMIN_USER_KEY);
    }
    setAdmin(null);
    const redirectSlug = slug || admin?.slug;
    window.location.href = redirectSlug ? `/${redirectSlug}/admin/login` : '/admin/login';
  };

  const getToken = () => {
    if (admin?.role === 'staff') return localStorage.getItem(STAFF_TOKEN_KEY);
    return localStorage.getItem(ADMIN_TOKEN_KEY);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading, getToken, isAuthenticated: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
